import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'

import { IBaseMediaItem } from 'types/media'
import { IRecentlyUsedMediaState } from 'store/types/recentlyUsedMedia'

const reducers = reducerCreatorProducer<IRecentlyUsedMediaState>()({
  setRecentlyUsedMedia: (
    state,
    action: PayloadAction<IBaseMediaItem | IBaseMediaItem[]>
  ) => {
    const mediaItems = Array.isArray(action.payload)
      ? action.payload
      : [action.payload]

    const uniqueItems = mediaItems.filter(
      newItem =>
        !state.externalMediaItems.some(
          (item: IBaseMediaItem) => item.path === newItem.path
        )
    )

    state.externalMediaItems = [...uniqueItems, ...state.externalMediaItems]
  },
  replaceRecentlyUsedMedia: (
    state,
    action: PayloadAction<IBaseMediaItem[]>
  ) => {
    state.externalMediaItems = action.payload
  }
})

export default reducers
